<img
  [homeyImage]="'thumbnail'"
  [homeyImageSrc]="apartment().mainPhoto.baseImage"
  class="flex-shrink-0 object-cover h-[90px] w-[90px] rounded-lg {{gray() ? 'grayscale opacity-50' : ''}}"
  [alt]="apartment().name"/>
<div class="overflow-hidden text-ellipsis">
  @if (openInPopup()) {
    <button class="font-medium fit-to-container cursor-pointer overflow-hidden text-nowrap text-ellipsis"
            (click)="openPopup()">{{ apartment().name }}
    </button>
  } @else {
    <a class="font-medium fit-to-container overflow-hidden text-nowrap text-ellipsis"
       [routerLink]="[baseRoute(), apartment().slug ?? apartment().id]">{{ apartment().name }}</a>
  }
  @if (showNeighbourhoodAndBorough()) {
    <p
      class="text-sm text-muted-color text-ellipsis overflow-hidden text-nowrap">{{ apartment().borough | boroughToText }}
    <p class="text-sm text-muted-color text-ellipsis overflow-hidden text-nowrap">{{ apartment().neighborhood }}</p>
  }
  <div class="flex gap-1 text-sm text-muted-color text-ellipsis overflow-hidden text-nowrap">
    <ng-content></ng-content>
  </div>

</div>
@if (perfectFit()) {
  <div class="absolute -top-2 -left-2 bg-orange-500 text-white px-1 py-[1px] rounded text-[0.60rem]">
    Perfect fit
  </div>
}
